import client from './client';
import { Testimonial, TestimonialPayload } from '../types/testimonial';

/** Every testimonial, hidden ones included, already in display_order. */
export async function getTestimonials(): Promise<Testimonial[]> {
  const res = await client.get('/api/admin/testimonials');
  return Array.isArray(res.data?.testimonials) ? res.data.testimonials : [];
}

export async function createTestimonial(payload: TestimonialPayload): Promise<Testimonial> {
  const res = await client.post('/api/admin/testimonials', payload);
  return res.data?.testimonial;
}

export async function updateTestimonial(
  id: string,
  payload: TestimonialPayload,
): Promise<Testimonial> {
  const res = await client.put(`/api/admin/testimonials/${id}`, payload);
  return res.data?.testimonial;
}

/**
 * Flip shown ⇄ hidden. The server owns the flip, not the client — sending an
 * explicit `is_active` would race a second admin who just changed it.
 *
 * The empty body object is deliberate: the gateway re-serialises `req.body` when
 * it proxies, and a PATCH with no body at all arrives upstream with a
 * Content-Length it never fulfils.
 */
export async function toggleTestimonial(id: string): Promise<Testimonial> {
  const res = await client.patch(`/api/admin/testimonials/${id}/toggle`, {});
  return res.data?.testimonial;
}

export async function reorderTestimonial(id: string, display_order: number): Promise<Testimonial> {
  const res = await client.patch(`/api/admin/testimonials/${id}/reorder`, { display_order });
  return res.data?.testimonial;
}

export async function deleteTestimonial(id: string): Promise<void> {
  await client.delete(`/api/admin/testimonials/${id}`);
}
